import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./Templates.module.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../../utils/Api";
import { connect } from "react-redux";
import { fetchDropdownList, fetchInitialTemplatesData, fetchTemplateContent } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";

export class Templates extends Component {
  constructor(props) {
    super(props);

    this.state = {
        lk_template_id:"1",
      content: "",
      placeholders: "",
      errorMessage: "",
      isLoading: false,
      isDataFetching: false,
      isScreenLoaded: false,
    };
  }

  componentDidMount = async() => {
    document.title = 'SMS Template - TechToMedix';
     await this.props.fetchInitialTemplatesData();
      await this.props.fetchTemplateContent(this.state.lk_template_id);
      if(this.props.templateContentData && !this.props.templateContentData.loading 
        && this.props.templateContentData.templateContent && 
        this.props.templateContentData.templateContent.content){
        this.setState({
            content: JSON.parse(this.props.templateContentData.templateContent.content)
        })
      }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  }


  // common form input handling
  handleInputChange = async(event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });

    if(name === "lk_template_id"){
      await this.props.fetchTemplateContent(val);
      if(this.props.templateContentData && !this.props.templateContentData.loading 
        && this.props.templateContentData.templateContent && 
        this.props.templateContentData.templateContent.content){
          this.setState({
            content: JSON.parse(this.props.templateContentData.templateContent.content)
        })
      }else{
        this.setState({
            content: ""
        })
      }
    }
  };


  getTemplateName = () => {
    const dropDowndata = this.props.initialTemplatesDropDownData.initialTemplatesData;
    let  templateData = dropDowndata &&
    dropDowndata.length > 0 &&
    dropDowndata.find((element, index) => (
        element.lk_template_id === parseInt(this.state.lk_template_id)
    ));
    return templateData && templateData.name ? templateData.name : "";
    
  }


  handleAddPlaceholder = (placeholder) =>{
    let content = this.state.content;
    content = content.concat(" " + placeholder);
   // console.log("content", content)
    this.setState({
        content: content
    })

  }

  getTemplatesLabel = (placeholder) => {
    let label = "";
    switch(placeholder) {
        case "<patient_name>":
            label = `Patient Name -`;
         break;
        case "<practioner_name>":
             label = `Practitioner Name -`;
        break;
        case "<appointmentDates>":
              label = `Appointment Dates -`;
        break;
        case "<practitioner_contact>":
              label = `Practitioner Contact -`;
        break;
        case "<sub_category_name>":
              label = `Subcategory Name -`;
        break;
        default:
         break;
    }
    return label;
  }

//   copyToClipboard = (e) => {
//     this.textArea.select();
//     document.execCommand('copy');
//     // This is just personal preference.
//     // I prefer to not show the the whole text area selected.
//     e.target.focus();
//     this.setState({ copySuccess: 'Copied!' });
//   };

  render() {

    const dropDowndata = this.props.initialTemplatesDropDownData.initialTemplatesData;

    const templateOptions = dropDowndata &&
    dropDowndata.length > 0 &&
    dropDowndata.map((element, index) => (
      <option key={index} value={element.lk_template_id}>
        {element.name}
      </option>
    ));
    const templatePlaceholdersData = dropDowndata &&
    dropDowndata.length > 0 &&
    dropDowndata.find((element, index) => (
      element.lk_template_id === parseInt(this.state.lk_template_id)
    ));

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <div className={style.templateMainWrapper}>
        <div className="row">
          <div className="col-md-12">
            <h3>SMS Template</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
            </p>
          </div>
        </div>
        <Formik
          initialValues={this.state}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            lk_template_id: Yup.string()
              .required("This field is required!"),
            content: Yup.string()
              .required("This field is required!"),
          })}
          onSubmit={async (data) => {
            // alert("SUCCESS!! :-)\n\n" + JSON.stringify(fields, null, 4));
            this.setState({
              isLoading: true,
            });
            // Payload to be sent
            const payload = {
                lk_template_id: data.lk_template_id,
                content: JSON.stringify(data.content),
            };
            // Headers
            const headers = {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            };
            try {
              const response = await api.post("template/save", payload, {
                headers: headers,
              });
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                  successMessage: "Template saved successfully!",
                });
                if (this.state.isEditMode) {
                  this.setState({
                    isLoading: false,
                    successMessage: "Error!",
                  });
                }
              }
              setTimeout(() => {
                this.setState({
                  successMessage: "",
                });
              }, 2000);
            } catch (error) {
              if (error.response) {
                this.setState({
                  isLoading: false,
                  errorMessage: "Internal server error occured",
                });
                setTimeout(() => {
                  this.setState({
                    errorMessage: "",
                  });
                }, 2000);
              }
              console.log("Error in save general setting", error);
            }
          }} >
              {(props)=>(
            <Form>
              <div className="form-box-shadow">
                {/* <div className="row">
                  <div className="col-md-12">
                    <h4>Upload Settings</h4>
                  </div>
                </div> */}
                  <div>
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-xl-12">
                        <label htmlFor="max_upload">
                          Choose a template for :
                        </label>
                      </div>
                      <div className="col-md-4 col-lg-4 col-xl-4">
                        <div className="form-group">
                          <Field
                            as="select"
                            id="lk_template_id"
                            name="lk_template_id"
                            value={this.state.lk_template_id}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (props.errors.lk_template_id && props.touched.lk_template_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                          {templateOptions}
                            </Field>
                          <ErrorMessage
                            name="lk_template_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12">
                            <h4>SMS -{" "} {this.getTemplateName(this.state.lk_template_id)}</h4>
                        </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-xl-12">
                        <label htmlFor="max_product_image_upload">
                          Message :
                        </label>
                      </div>
                      <div className="col-md-12 col-lg-12 col-xl-12">
                        <div className="form-group">
                          <Field
                            as="textarea"
                            id="content"
                            rows={4}
                            name="content"
                            placeholder="SMS Template"
                            value={this.state.content}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (props.errors.content &&
                                props.touched.content
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="content"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <label className="mr-2">Available Placeholders :</label>
                            <p>{`(Copy & Paste to the above box at the appropriate places.)`}</p>
                        </div>
                        <div className="col-md-12 d-flex flex-wrap">
                        
                        {/* <Button onClick={()=>this.handleAddPlaceholder(item)} key={index} className="mr-3">{item}</Button> */}
                             <ul>
                           {templatePlaceholdersData.placeholders && JSON.parse(templatePlaceholdersData.placeholders).length > 0 && 
                           JSON.parse(templatePlaceholdersData.placeholders).map((item, index)=>(
                            <li key={index} className="form-group mr-3">
                                <div className="d-flex">
                                    <label className="mr-1">{this.getTemplatesLabel(item)}</label>
                                    <p>{item}</p>
                                </div>
                            </li>
                           ) 
                           )}
                           </ul>
                           {templatePlaceholdersData && (!templatePlaceholdersData.placeholders || templatePlaceholdersData.placeholders.length === 0) && (
                            <p>No Placeholders Available!</p>
                           )}
                        </div>
                    </div>

                    
                    <hr />
                  </div>
                
              </div>
              <div className="row">
                <div className="col-md-12">
                  {this.state.isLoading ? (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} alt="loader" className={style.loading} />
                    </div>
                  ) : (
                    <div>
                      {this.state.successMessage && (
                        <p className={style.successMessage}>
                          {this.state.successMessage}
                        </p>
                      )}
                      {this.state.errorMessage && (
                        <p className={style.errorMessage}>
                          {this.state.errorMessage}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className={`row ${style.settingBtnWrapper}`}>
                {/* <div
                  className={`col-md-6 d-flex justify-content-center justify-content-sm-start ${style.btnWrapper}`}
                >
                    <Button type="button" color="primary">
                    Cancel
                  </Button>
                </div> */}
                <div
                  className={`col-md-12 d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
                >
                  <Button type="submit" color="primary">
                    Save
                  </Button>
                </div>
              </div>
            </Form>
          
          )}
          </Formik>
      </div>
    );
  }
}

// export default Setting;

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    initialTemplatesDropDownData: state.initialTemplatesData,
    templateContentData: state.templateContent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchInitialTemplatesData: () => dispatch(fetchInitialTemplatesData()),
    fetchTemplateContent: (lk_template_id) => dispatch(fetchTemplateContent(lk_template_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Templates);
